import type { StreamProvider } from '@vgtv/api-client';
import { ProviderAccessMap } from '@vgtv/svp-access/lib/access_mappings';

import { isSportAccessLevel } from '../../../../utils/player/asset';
import { useProvider } from '../../hooks/useProvider';
import { UpcomingBadges } from '../../components/UpcomingBadges/UpcomingBadges';
import { ComponentChild } from 'preact';

export const PaywallLayoutLabel = ({
  accessLevel,
  label,
  hasAccess,
}: {
  accessLevel?: ProviderAccessMap[StreamProvider];
  label?: string | ComponentChild;
  isMobile: boolean;
  hasAccess: boolean;
}) => {
  const { configProvider } = useProvider();
  const color =
    !hasAccess && isSportAccessLevel(configProvider, accessLevel)
      ? 'secondary'
      : 'primary';

  return <UpcomingBadges color={color} label={label} />;
};
